import { get } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/calpoly-dates?pretty
export const calpolyDates = async() => {
  return get('calpoly-dates')
}